import React from 'react'
import { func, array, number, string } from 'prop-types'

import TypeLockup from '@/component/Composition/TypeLockup'
import EmbellishedCardGrid from '../EmbellishedCardGrid'

import Container from '@/component/Primitive/Container'
import Panel from '@/component/Primitive/Panel'
import Stack from '@/component/Primitive/Stack'
import SearchControl from '@/component/Primitive/SearchControl'
import TextAlign from '@/component/Primitive/TextAlign'
import SmartLink from '@/component/Primitive/SmartLink'
import PaginationSummary from '@/component/Primitive/PaginationSummary'

const SearchResults = ({
  onSearch,
  onNextPage,
  onPrevPage,
  results,
  searchTerm,
  sortOption,
  total,
  page,
  pageSize
}) => {
  return (
    <Stack gap="large">
      <Container center gutter size="wide">
        <Panel allowOverflow>
          <Stack gap="large">
            <TypeLockup
              title={searchTerm ? 'Search results' : 'Search'}
              titleSize="heading1"
            />

            <Container center gutter size="medium">
              <SearchControl
                onSubmit={onSearch}
                initialValue={searchTerm}
                autocompletions={[]}
              />
            </Container>

            {searchTerm && results.length === 0 && (
              <Container center gutter size="medium">
                <TextAlign center>
                  No results found. Please try a different search term, or
                  explore content from our{' '}
                  <SmartLink to="/section" as="/">
                    homepage
                  </SmartLink>
                  .
                </TextAlign>
              </Container>
            )}

            {searchTerm && results.length > 0 && (
              <>
                <EmbellishedCardGrid
                  subtitle={`Showing results for “${searchTerm}”`}
                  items={results}
                />
                <TextAlign center>
                  <PaginationSummary
                    onNext={onNextPage}
                    onPrevious={onPrevPage}
                    currentSlide={page}
                    totalSlides={Math.ceil(total / pageSize)}
                  />
                </TextAlign>
              </>
            )}
          </Stack>
        </Panel>
      </Container>
    </Stack>
  )
}

SearchResults.propTypes = {
  onSearch: func.isRequired,
  onNextPage: func.isRequired,
  onPrevPage: func.isRequired,
  results: array.isRequired,
  searchTerm: string,
  sortOption: string,
  total: number,
  page: number,
  pageSize: number
}

export default SearchResults
